import { EmptyState } from '@libs/components';

import { DesertedIcon } from 'src/assets';
import { useFetchPriceQueries, useTranslation } from 'src/hooks';
import { DashboardWalletLoader } from 'src/content-loaders';

import { useAllAssetsTable } from './useAllAssetsTable';
import { allAssetsEmptyStateTitle } from './helper/allAssetsEmptyStateTitle';

import {
  CustomSearchInput,
  TableContainer,
  TableHeaderWrapper,
  CustomTabs,
  Title,
  TabsAndSearchWrapper,
  CustomTable,
} from './styles';
import { useAllAssetTabs } from './useAllAssetsTabs';

type AllAssetsTableProps = {
  hasActions?: boolean;
  className?: string;
};
const AllAssetsTable: React.FC<AllAssetsTableProps> = ({
  hasActions,
  className,
}) => {
  const { triggerRefetchForDashboardPrices } = useFetchPriceQueries();

  const {
    isCrypto,
    setActiveTab,
    shouldHaveExtraColumns,
    tabItems,
    walletType,
    title,
    activeTab,
  } = useAllAssetTabs(hasActions);

  const handleOnTabClick = (val: string | number) => {
    setActiveTab(val);
    triggerRefetchForDashboardPrices();
  };

  const { columns, data, searchInputValue, setSearchInputValue, loading } =
    useAllAssetsTable(
      walletType,
      shouldHaveExtraColumns,
      isCrypto,
      hasActions,
      setActiveTab
    );
  const { t } = useTranslation();

  let renderItem;

  const emptyStateTitle = allAssetsEmptyStateTitle(
    searchInputValue,
    walletType
  );

  if (loading) {
    renderItem = <DashboardWalletLoader />;
  } else if (!data.length) {
    renderItem = <EmptyState img={DesertedIcon} title={t(emptyStateTitle)} />;
  } else {
    renderItem = (
      <CustomTable data={data} columns={columns} hasStickyHeader={false} />
    );
  }

  return (
    <TableContainer className={className}>
      <TableHeaderWrapper>
        <Title type="titleTwo" fontFamily="primaryBold">
          {title}
        </Title>
        <TabsAndSearchWrapper>
          <CustomTabs
            tabs={tabItems}
            activeTab={activeTab}
            handleTabClick={handleOnTabClick}
          />
          <CustomSearchInput
            searchInputValue={searchInputValue}
            setSearchInputValue={setSearchInputValue}
          />
        </TabsAndSearchWrapper>
      </TableHeaderWrapper>
      {renderItem}
    </TableContainer>
  );
};
export default AllAssetsTable;
